import React from 'react';
import Slider from "react-slick";

const Testimonials = () =>{
    
    var settings = {
        dots: true,
        fade: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive:[
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1 
                }
            }
        ]
    };    

    return (
        <Slider className="testimonialsSlider" {...settings}>        
            <div>
                <h6>MANGO PEOPLE SHOP</h6>
                <span>The improvements made to the platform resulted in a 170% increase in traffic to the store. Enthusiastic and professional, the team effectively managed the project with their industry expertise and communication skills. Their success led to a long-term partnership with the client.</span>
            </div>
            <div>
                <h6>My PoojaBox</h6>
                <span>The improvements made to the platform resulted in a 170% increase in traffic to the store. Enthusiastic and professional, the team effectively managed the project with their industry expertise and communication skills. Their success led to a long-term partnership with the client.</span>
            </div>
            <div>
                <h6>Arlosky</h6>
                <span>The improvements made to the platform resulted in a 170% increase in traffic to the store. Enthusiastic and professional, the team effectively managed the project with their industry expertise and communication skills. Their success led to a long-term partnership with the client.</span>
            </div>
        </Slider>
    )
}

export default Testimonials;